/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type ListingDetailParkingSlotResponseDtoParkingType = typeof ListingDetailParkingSlotResponseDtoParkingType[keyof typeof ListingDetailParkingSlotResponseDtoParkingType];


export const ListingDetailParkingSlotResponseDtoParkingType = {
  GARAGE: 'GARAGE',
  GARAGE_SPACE: 'GARAGE_SPACE',
  OUTDOOR_SPACE: 'OUTDOOR_SPACE',
  COVERED_OUTDOOR_SPACE: 'COVERED_OUTDOOR_SPACE',
} as const;
